import _Vue from 'vue'
import i18n from '@/i18n'
import VueI18n from 'vue-i18n'

export enum Roles {
  ADMIN = 'ADMIN',
  AGENT = 'AGENT',
  EMPLOYEE = 'EMPLOYEE',
  WHOLESALER = 'WHOLESALER',
  ACCOUNTANT = 'ACCOUNTANT',
}

export default {
  install: (Vue: typeof _Vue) => {
    Vue.prototype.$utils = {
      makeSelectable: (items: string[] | Iterable<string>) => {
        if (Array.isArray(items)) {
          return items.map(item => ({ text: i18n.t(item), value: item }))
        } else {
          return Object.values(items).map(item => ({
            text: i18n.t(item),
            value: item,
          }))
        }
      },
    }
  },
}

declare module 'vue/types/vue' {
  interface Vue {
    $utils: {
      makeSelectable: (
        items: string[] | Iterable<string>,
      ) => {
        text: VueI18n.TranslateResult
        value: any
      }[]
    }
  }
}
